import { useState } from 'react'
import type { FC } from 'react'

import DeleteIcon from '@/assets/img/delete-icon.svg?react'
import DotsSvg from '@/assets/img/dots.svg?react'
import EditIcon from '@/assets/img/edit-pan.svg?react'
import SearchIcon from '@/assets/img/search.svg?react'
import Dropdown from '@/compoments/common/Dropdown'
import DropdownList from '@/compoments/DropdownList'
import EditChatModal from '@/compoments/modals/EditChatModal'
import { getUser } from '@/features/auth/authSlice'
import { useAppSelector } from '@/hooks/redux'
import {
    useLeaveChatMutation,
    useRemoveChatMutation,
} from '@/services/chats/chats'
import type { User } from '@/types'
import type { IChat } from '@/types/chats'
import { getMediaUrl } from '@/utils/helpers'

interface IChatHeaderProps {
    chat: IChat
    searchAction: React.Dispatch<React.SetStateAction<boolean>>
}
export const ChatHeader: FC<IChatHeaderProps> = ({ chat, searchAction }) => {
    const [removeChat] = useRemoveChatMutation()
    const [leaveChat] = useLeaveChatMutation()
    const [editChatModal, setEditChatModal] = useState<boolean>(false)
    const user = useAppSelector(getUser)
    const editHandler = (chat: IChat) => {
        setEditChatModal(true)
    }
    const recipient = chat?.users?.find((u: User) => u.id !== user?.id)

    const getStatus = () => {
        if (chat?.isGroup) {
            return chat?.users?.every((user) => user.status === 'offline')
                ? 'offline'
                : 'online'
        } else {
            return recipient?.status
        }
    }

    if (!chat) {
        return null
    }

    return (
        <div className="chat-workflow--header">
            <div className="chat-select">
                <div className="ico-avatar ico-avatar-group btn btn--sm btn--square">
                    {chat?.isGroup ? (
                        chat?.users?.map((member) => (
                            <div
                                key={member.id}
                                className="ico-avatar btn btn--sm btn--square"
                            >
                                <img
                                    src={getMediaUrl(member?.photo)}
                                    alt={member.fullName}
                                />
                            </div>
                        ))
                    ) : (
                        <div className="ico-avatar btn btn--sm btn--square">
                            <img
                                src={getMediaUrl(recipient?.photo)}
                                alt={recipient?.fullName}
                            />
                        </div>
                    )}
                </div>
                <div className="chat-select-user-info">
                    <div className="user-info-row">
                        <p className="user-info-name">
                            {chat.name || recipient?.fullName}
                        </p>
                    </div>
                    <div className="user-info-row">
                        <p className="user-info-status">{getStatus()}</p>
                    </div>
                </div>
            </div>
            <div className="chat-workflow--header-tools">
                <button
                    type="button"
                    className="btn btn-tool"
                    onClick={() => searchAction((prev) => !prev)}
                >
                    <span className="ico">
                        <SearchIcon />
                    </span>
                </button>
                <div className="text-right sticky-end">
                    <Dropdown
                        closeSelf={true}
                        dropdownClasses="flex flex-col"
                        button={
                            <span className="ico">
                                <DotsSvg />
                            </span>
                        }
                        menuClassName="dropdown-md"
                        menu={
                            <DropdownList
                                list={[
                                    // {
                                    //     title: 'View Profile',
                                    //     icon: <ProfileIcon />,
                                    //     action: () => {},
                                    // },
                                    {
                                        title: 'Edit Сhat',
                                        icon: <EditIcon />,
                                        action: () => {
                                            editHandler(chat)
                                        },
                                    },
                                    {
                                        title: `${chat?.userId === user?.id ? 'Delete Chat' : 'Leave Chat'} `,
                                        icon: <DeleteIcon />,
                                        action: () => {
                                            if (chat?.userId === user?.id) {
                                                removeChat(chat.id)
                                            } else {
                                                leaveChat(chat.id)
                                            }
                                        },
                                        type: 'btn-drp-link-danger',
                                    },
                                ]}
                            />
                        }
                    />
                </div>
            </div>
            {editChatModal && (
                <EditChatModal
                    isOpen={editChatModal}
                    onClose={() => {
                        setEditChatModal(false)
                    }}
                    chat={chat}
                />
            )}
        </div>
    )
}
